import DropUser from "./DropUser";
import funcs from "tools/functions";
import { getStorage } from "store/local";

function NavBar() {
  const session = getStorage("ctxSession");
  const terminal = funcs.getCookie();
  if (!session) {
    window.location.href = "/login";
    return false;
  }

  return (
    <div id="navbar" className="container w-full h-full">
      <div className="flex columns-2 h-full justify-end">
        <div className="hidden h-full items-center md:flex lg:flex xl:flex 2xl:flex border-r-[0.4px] border-gray-700">
          <span
            className="truncate text-white text-base text-end pr-4 my-auto max-w-md"
            title={session?.company_name}
          >
            {session?.company_name}
          </span>
        </div>
        {terminal?.device_name && (
          <div className="hidden h-full space-x-2 items-center md:flex lg:flex xl:flex 2xl:flex border-r-[0.4px] border-gray-700 px-3">
            <p className="truncate text-white text-base text-center mx-auto my-auto">
              TERMINAL:{" "}
            </p>
            <span className="text-white font-bold truncate">
              {terminal.device_name}
            </span>
          </div>
        )}

        <div className="container text-end pr-5 my-auto w-auto">
          <DropUser session={session} />
        </div>
      </div>
    </div>
  );
}

export default NavBar;
